import * as Ajax from "../../pwa/ajax";
import * as BucketTools from "./bucket";
import * as INodoTools from "./inodo";
import * as Functions from "./functions";

const urlGaleria = window.config.Statics.GaleriaUrl;
const urlBacket = window.config.Statics.BucketUrl;
let html = "";

export const insertSliderFunctionality = (galeriaId) => {
    let nodoSlider = $("#sliderContainer[data-id='" + galeriaId + "']").parent();
    let nodoChildLi = $("#sliderContainer[data-id='" + galeriaId + "'] ul li");
    if (nodoChildLi.length > 1) {
        var timeOut;
        //Cuento la cantidad de slides
        var slides = nodoChildLi.length;
        //Creo la navegacion
        nav();
        //Activo la primera
        var pos = 1;
        nodoSlider.find('.navegacion span').eq(pos - 1).addClass('activo');

        // Funciones a realizar cuando inicia
        slideActiva();
        total();
        epigrafe();

        //Altura flechas
        let alturaContenedor = nodoSlider.height();
        let galeriaButton = nodoSlider.find('button');
        if ($(window).width() < 768) { galeriaButton.height(alturaContenedor) }
        galeriaButton.css('top', (alturaContenedor / 2) - 23);
        flechas();

        //Crea la navegacion // VER ESTO QUE NO PEGA LO QUE CREA    
        function nav() {
            for (var i = 0; i < slides; i++) {
                nodoSlider.find('.navegacion').append('<span data-slide="slide' + i + '" class="slide-' + i + '"></span>');
            }
        }

        // Activa las flechas
        function flechas() {
            let galeriaPrev = nodoSlider.find('.prev');
            let galeriaNext = nodoSlider.find('.next');
            if (pos !== 1) {
                galeriaPrev.addClass("activo");
                galeriaPrev.removeClass('primero');
            } else {
                galeriaPrev.removeClass('activo');
                galeriaPrev.addClass('primero');
            }
            if (pos !== slides) {
                galeriaNext.addClass('activo');
                galeriaNext.removeClass('ultimo');
            } else {
                galeriaNext.removeClass('activo');
                galeriaNext.addClass('ultimo');
            }
        }

        //Activa la slide seleccionada

        function slideActiva() {
            nodoChildLi.removeClass('activo');
            nodoChildLi.addClass('off');
            nodoChildLi.removeClass('previo');
            nodoChildLi.eq(pos - 2).addClass('previo');
            nodoChildLi.eq(pos).removeClass('previo');
            nodoChildLi.eq(pos - 1).toggleClass('off activo');
            if (pos == 1) {
                nodoChildLi.removeClass('previo');
            } else {}
        }

        //Toma el texto de cada imagen y lo replica
        function epigrafe() { 
            var epigrafe = $("#sliderContainer[data-id='" + galeriaId + "'] ul li.activo img");
            var creditoFuente = (epigrafe.attr('data-fuente') != "") ? '  Fuente: ' + epigrafe.attr('data-fuente') : "";
            var creditoAutor = (epigrafe.attr('data-autor') != "") ? ' - Crédito: ' + epigrafe.attr('data-autor') : "";

            var creditoCompleto = '&nbsp;&nbsp;<span class="fuente">' + creditoFuente + creditoAutor + '</span>';

            //var CreditoCompleto = (epigrafe.attr('data-fuente') != "") ? '<span class="fuente"> Fuente: ' + epigrafe.attr('data-fuente') + '</span>' : "";
            var autor = (epigrafe.attr('data-autor') != "") ? '<span class="autor"> Crédito: ' + epigrafe.attr('data-fuente') + '</span>' : "";
            $('#epigrafe[data-id="' + galeriaId + '"]').html(epigrafe.attr('alt') + creditoCompleto);
        }

        // Crea el total y el actual numero de slides
        function total() {
            var total = (pos) + ' de ' + slides;
            $('#total[data-id="' + galeriaId + '"]').html(total);
        }
        //Pregunta si es la primera
        function moveLeft() {
            reloadSrc();
            if (pos === 1) {
                pos = slides;
            } else {
                pos = pos - 1;
            }
            slideActiva();
            total();
            flechas();
        };

        //Pregunta si es la ultima
        function moveRight() {
            reloadSrc();
            if (pos == slides) {
                pos = 1;
            } else {
                pos = pos + 1;
            }
            slideActiva();
            total();
            flechas();
        };

        /*stopea el video que se esta reproduciendo y si tiene autoplay se lo quita*/
        function reloadSrc() {
            let sliderIframe = $('#sliderContainer[data-id="' + galeriaId + '"] ul li.activo iframe');
            if (sliderIframe.length) {
                var strReload = sliderIframe.attr('src');
                var strReloadNew = strReload.replace('autoplay=1', 'autoplay=0');
                sliderIframe.attr('src', strReloadNew);
            }
        };

        /*agrega autoplay al video que esta en el elemento visible*/
        function addAutoplay() {
            let sliderIframe = $('#sliderContainer[data-id="' + galeriaId + '"] ul li.activo iframe');
            if (sliderIframe.length) {
                var str = sliderIframe.attr('src');
                var strNew = str.replace('autoplay=0', 'autoplay=1');
                sliderIframe.attr('src', strNew);
            }
        };

        function botonActivo() {
            nodoSlider.find('.navegacion span').removeClass('activo');
            nodoSlider.find('.navegacion span').eq(pos - 1).addClass('activo');
        };

        /*los botones ejecutan las funciones anteriores*/
        $('.prev').click(function() {
            moveLeft();
            botonActivo();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        $('.next').click(function() {
            moveRight();
            botonActivo();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        //Activa el slide segun la posicion del menu
        $('.navegacion span').click(function() {
            reloadSrc();
            pos = $(this).attr('data-slide');
            pos = parseInt(pos);
            botonActivo();
            slideActiva();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        //Swipe
        $("#sliderContainer[data-id='" + galeriaId + "'] ul li").first().addClass('primero');
        $("#sliderContainer[data-id='" + galeriaId + "'] ul li").last().addClass('ultimo');

        $("#sliderContainer[data-id='" + galeriaId + "']").swiperight(function() {
            if ($('.activo.primero').length) {} else {
                moveLeft();
            }
        });
        $("#sliderContainer[data-id='" + galeriaId + "']").swipeleft(function() {
            if ($('.activo.ultimo').length) {} else {
                moveRight();
            }
        });

        Functions.functions();

    }
}


const getHtml = (ajaxData, galeriaId, classGaleria) => {
    const imagesArr = ajaxData.imagenes;
    //let liClassAttr = "foto-1 on";
    if (imagesArr && imagesArr.length > 0) {
        let liClassAttr = "";

        html = //'<input id="titulo" type="hidden" value="' + ajaxData.titulo + '>' +
            '<div class="galeria conModal vertical">' +
            '<div id="sliderContainer" class="f-imagenRelacionada" data-id="' + galeriaId + '">' +
            '<span title="Ampliar imagen" class="icon-ampliar"></span><span title="Cerrar modal" class="icon-cerrar"></span>';
        html += `<ul>`;

        for (let img of Array.from(imagesArr)) {

            let imgHtml = "";
            if (img.id > 0 && img.extension != null && img.extension != "") {
                let fuenteNombre = (img.fuenteNombre != null && img.fuenteNombre != undefined && img.fuenteNombre != "") ? `${img.fuenteNombre}` : ""; 
                let creditoAutor = (img.autor != null && img.autor != undefined && img.autor != "") ? `${img.autor}` : ""; 

                imgHtml = `<img src="${BucketTools.urlBucketBalance(urlBacket, img.id, BucketTools.getImageSrcPath(img, "galeria", classGaleria), "", img.extension)}" id="imagen" itemprop="" alt="${INodoTools.getHtml(img.epigrafe)}" data-fuente="${fuenteNombre}" data-autor="${creditoAutor}"/>`;
            }

            html += `<li>
                      ${imgHtml}            
                     </li>`;
        }
        
        html += "</ul>" +
            '</div>' +
            '<div class="navegacion"></div>' +
            '<button href="#" id="prev" class="prev icon-izquierda"></button>' +
            '<button href="#" id="next" class="next icon-derecha"></button>' +
            '<div class="borde"></div>' +
            '</div>' +
            '<figcaption class="epigrafe floatFix" id="epigrafe" data-id="' + galeriaId + '"></figcaption>' +
            '<div class="total" id="total" data-id="' + galeriaId + '"></div>' +
            //'<div class="epigrafe">' + INodoTools.getHtml(ajaxData.epigrafe) + '</div>' + 
            //'<div class="total">Foto <div id="numberImage">1</div> de '+ imagesArr.length +'</div>' +
            //'<div class="herramientas floatFix">' +
            //    '<button id="facebookShareImage" class="icon-facebook" title="Compartir en Facebook"></button>' + 
            //    '<button id="twitterShareImage"  class="icon-twitter" title="Compartir en Twitter"></button>' +
            //'</div>'+
            '</div>';
    }
    return html;
}

const renderGaleria = (ajaxData, divHolder) => {
    divHolder.innerHTML = getHtml(ajaxData, ajaxData.id, divHolder.getAttribute("class"));
    insertSliderFunctionality(ajaxData.id);
}

/**
 * Returns the HTML <section> of a specific Galery with the data on it.
 * @param {Number} idGaleria - Galery Id
 * @param {Number} divHolder -  <div> where the returned HTML sections galeries will be placed. 
 * @return {String} HTML <section>
 */
export const getGaleria = (idGaleria, divHolder) => {
    Ajax.get(urlGaleria + idGaleria)
        .then(result => renderGaleria(JSON.parse(result), divHolder), (status) => console.log("Error Ajax call: ", status));
}

/**
 * Returns a collection of <section> with their data on it.
 * @param {HTMLDivElement} divElements - One or more <div>s where the returned HTML galery sections will be placed.
 * @param {Number} divId - If null, will be extracted from 'data-id' attr of each divElement.
 * @return {HTMLStrings} Collection of HTML <section>s galeries.
 */
export const getAllGalerias = (divElements, divId) => {
    for (let div of Array.from(divElements)) {
        getGaleria(divId || div.getAttribute("data-id"), div);
        html = "";
    }

}


// WEBPACK FOOTER //
// ./Statics/scripts/common/slide.js